const Report = () =>
  import(/* webpackChunkName: "crm-ticket" */ '@/pages/crm/ticket/index.vue')
const Create = () =>
  import(/* webpackChunkName: "crm-ticket" */ '@/pages/crm/ticket/create.vue')
const Edit = () =>
  import(/* webpackChunkName: "crm-ticket" */ '@/pages/crm/ticket/edit.vue')

const Respond = () =>
  import(/* webpackChunkName: "crm-ticket" */ '@/pages/crm/ticket/respond.vue')

export default {
  path: 'ticket',
  meta: {
    label: 'ticket',
    auth: 'ticket'
  },
  component: {
    name: 'Ticket',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CrmTicketReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'CrmCreateTicket',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'CrmEditTicket',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    },
    {
      name: 'CrmRespondTicket',
      path: 'respond/:id',
      meta: {
        label: 'respond',
        auth: true
      },
      component: Respond,
      props: true
    }
  ]
}
